import { memo } from 'react';

import { ShareBrandContextRow } from '~/components/ShareModal/components/ShareBrandContextRow';
import { ShareModalSectionLabel } from '~/components/ShareModal/components/ShareModalSectionLabel';
import { useCreateShowcaseDesign } from '~/components/ShowcaseModal/CreateShowcaseDesignProvider';

/** Brand-context picker section: binds the presentational row to the design context. */
export const CreateShowcaseDesignBrandContextSection = memo(() => {
  const { brandingDisabled, brandCustomizationEnabled, selectedContextSourceId, handleSelectBrandContext } =
    useCreateShowcaseDesign();

  return (
    <div className="flex flex-col gap-1">
      <ShareModalSectionLabel title="Brand context" />
      <ShareBrandContextRow
        data-testid="CREATE_COLLECTION_LINK_DESIGN_BRAND_CONTEXT_ROW"
        disabled={brandingDisabled}
        showUpsell={!brandCustomizationEnabled}
        onSelectContextSource={handleSelectBrandContext}
        selectedContextSourceId={selectedContextSourceId}
      />
    </div>
  );
});

CreateShowcaseDesignBrandContextSection.displayName = 'CreateShowcaseDesignBrandContextSection';
